import type { PriceGroup } from "@/mocks/priceTables";
import PriceRowTable from "./PriceRowTable";

/**
 * 料金表ページ「医療脱毛」タブ専用の男性料金ブロック。
 *
 * 詳細ページ（Version 100）と同じルールで、男性（顔・首）〜男性（ボディ）を
 * ひと続きのチャコール背景エリアにまとめて描画する。
 * 女性料金は従来どおり明るい背景のまま（このブロックには含めない）。
 *
 * 配色：チャコール背景 × ウォームホワイト文字 × ゴールド系英字アクセント × 薄い白罫線。
 *
 * 左右位置（Version 104）：
 * チャコール背景は外側（ネガティブマージン）へ広げつつ、内側のpaddingで相殺することで、
 * 料金表（施術名の左端・金額の右端・罫線の左右端）の座標を女性料金表と完全に一致させる。
 * padding値は `.u-container` の左右padding（24px / 40px / 64px）と対応させている。
 */
export default function HairRemovalMalePriceBlock({ groups }: { groups: PriceGroup[] }) {
  if (groups.length === 0) return null;

  return (
    <div className="-mx-6 bg-foreground-950 px-6 py-10 md:-mx-10 md:px-10 md:py-12 xl:-mx-16 xl:px-16">
      {groups.map((group, index) => (
        <div key={group.title} className={index === 0 ? "" : "mt-10"}>
          <div className="flex flex-wrap items-baseline gap-x-4 gap-y-2 md:gap-x-5">
            <span className="en-eyebrow text-[10px] text-accent-400 md:text-[11px]">{group.en}</span>
            <span className="font-heading text-lg text-background-50">{group.title}</span>
            <span className="hidden h-px flex-1 bg-background-50/20 md:block" />
          </div>

          {group.lead ? (
            <p className="mt-4 text-[12.5px] leading-[1.9] text-background-200">{group.lead}</p>
          ) : null}

          <PriceRowTable rows={group.rows} tone="dark" />
        </div>
      ))}
    </div>
  );
}